import React from 'react';
import PropTypes from 'prop-types';
import { Flex, NumberInput, ActionIcon } from '@mantine/core';
import { MinusIconMd, MinusIconSm, PlusIconMd, PlusIconSm } from '@chownow/pantry/icons';

export default function Counter({
  quantity,
  increment,
  decrement,
  set,
  size = 'md',
  variant = 'outlined',
  minQuantity = 1,
  maxQuantity = 99,
}) {
  const sizeStyles = {
    sm: {
      height: '40px',
      width: '92px',
    },
    md: {
      height: '48px',
      width: '116px',
    },
  };

  const variantStyles = {
    outlined: {
      border: '1px solid var(--border-primary)',
      backgroundColor: 'transparent',
    },
    filled: {
      border: 'none',
      backgroundColor: 'var(--surface-secondary)',
    },
  };

  const buttonSize = size === 'sm' ? '24px' : '32px';

  return (
    <Flex
      style={{
        ...sizeStyles[size],
        borderRadius: 'var(--mantine-radius-xl)',
        alignItems: 'center',
        justifyContent: 'center',
        ...variantStyles[variant],
      }}
    >
      <ActionIcon
        onClick={decrement}
        disabled={quantity === minQuantity}
        style={{
          borderRadius: 'var(--mantine-radius-xs)',
          width: buttonSize,
          height: buttonSize,
          opacity: quantity === minQuantity ? 0 : 1,
        }}
        ml="lg"
        h="md"
      >
        {size === 'sm' ? <MinusIconSm /> : <MinusIconMd />}
      </ActionIcon>

      <NumberInput
        value={quantity}
        onChange={value => set(value || minQuantity)}
        hideControls
        styles={{
          input: {
            textAlign: 'center',
            border: 'none',
            height: size === 'sm' ? '20px' : '32px',
            backgroundColor: 'transparent',
            fontSize: size === 'sm' ? 'var(--mantine-font-size-sm)' : 'var(--mantine-font-size-md)',
            margin: 0,
            padding: 0,
            color: 'var(--content-primary)',
            width: size === 'sm' ? '20px' : '30px',
          },
          wrapper: {
            width: size === 'sm' ? '20px' : '30px',
            height: '40px',
          },
          inputWrapper: {
            width: size === 'sm' ? '20px' : '30px',
          },
        }}
        min={minQuantity}
        max={maxQuantity}
        clearable={false}
        rightSection={null}
        mb="0"
      />

      <ActionIcon
        onClick={increment}
        disabled={quantity === maxQuantity}
        style={{
          borderRadius: 'var(--mantine-radius-xs)',
          width: buttonSize,
          height: buttonSize,
          opacity: quantity === maxQuantity ? 0 : 1,
        }}
        mr="lg"
        h="md"
      >
        {size === 'sm' ? <PlusIconSm /> : <PlusIconMd />}
      </ActionIcon>
    </Flex>
  );
}

Counter.propTypes = {
  quantity: PropTypes.number.isRequired,
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  variant: PropTypes.oneOf(['outlined', 'filled']),
  minQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
};
